export default {
    methods: {
        getRegionalIndicatorSymbol(letter) {
            return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
        },
        getCountryFlagEmoji(country) {
            return this.getRegionalIndicatorSymbol(country[0]) + this.getRegionalIndicatorSymbol(country[1]);
        },
    },
};
